import { useState, useCallback } from 'react';

import { Dispatch, SetStateAction } from 'react';

export type SortFieldState = string;
export type SortOrderState = string;
export type SortValueState = string;
export type SetSortField = Dispatch<SetStateAction<SortFieldState>>;
export type SetSortOrder = Dispatch<SetStateAction<SortOrderState>>;
export type SetValueOrder = Dispatch<SetStateAction<SortValueState>>;
export type OnChangeSortState = (
  sortField: SortFieldState,
  sortOrder: SortOrderState,
  sortValue?: SortValueState
) => void;

export const useSortState = (
  defaultSortField: SortFieldState = '',
  defaultSortOrder: SortOrderState = '',
  defaultValueOrder: SortValueState = ''
) => {
  const [sortField, setSortField] = useState<SortFieldState>(defaultSortField);
  const [sortOrder, setSortOrder] = useState<SortOrderState>(defaultSortOrder);
  const [sortValue, setSortValue] = useState<SortOrderState>(defaultValueOrder);

  const onChangeSortState = useCallback((
    newSortField: SortFieldState,
    newSortOrder: SortOrderState,
    newSortValue:  SortValueState = ''
  ) => {
    setSortField(newSortField);
    setSortOrder(newSortOrder);
    setSortValue(newSortValue);
  }, [
    setSortField,
    setSortOrder,
    setSortValue
  ]);

  const resetSortState = useCallback(() => {
    setSortField(defaultSortField);
    setSortOrder(defaultSortOrder);
    setSortValue(defaultValueOrder);
  }, [
    defaultSortField,
    setSortField,
    defaultSortOrder,
    setSortOrder,
    defaultValueOrder,
    setSortValue
  ]);

  return {
    sortField,
    sortOrder,
    sortValue,
    onChangeSortState,
    setSortField,
    setSortOrder,
    setSortValue,
    resetSortState
   } as const;
};
